import { createFileRoute } from '@tanstack/react-router';

import { ShareLinkDetailPage } from '../features/sharing/share-link-detail-page';

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/$shareLinkId/',
)({ component: ShareLinkDetailRoute });

function ShareLinkDetailRoute() {
  return <ShareLinkDetailPage {...Route.useParams()} />;
}
